import { Directive, EventEmitter, Input, Output } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms';
import { FormQuestion } from '@models/company/company-register';

@Directive()
export abstract class QuestionBaseDirective implements ControlValueAccessor, Validator {
  @Input() id!: string;
  @Input() question!: FormQuestion;

  @Output() nextQuestion = new EventEmitter<FormControl>();
  @Output() skipQuestion = new EventEmitter<FormControl>();

  get required(): boolean {
    return this.question?.required;
  }

  get label(): string {
    return this.question?.field?.label ?? '';
  }

  get placeholder(): string {
    return this.question?.field?.placeholder ?? '';
  }

  get errorMsg(): string {
    return this.question?.field?.errorMsg ?? '';
  }

  abstract control: AbstractControl;

  abstract writeValue(obj: any): void;
  abstract registerOnChange(fn: any): void;
  abstract registerOnTouched(fn: any): void;
  abstract setDisabledState?(isDisabled: boolean): void;

  /**
   * Init control with question baseValidatiors and required values
   * @param { FormQuestion } question
   * @return { FormControl } a new control with validators
   */
  initFormControl(question: FormQuestion): FormControl {
    return new FormControl(undefined, [
      ...(question.baseValidators || []),
      ...(question.required ? [Validators.required] : []),
    ]);
  }

  validate(_: any): ValidationErrors | null {
    return this.control?.errors ?? null;
  }
}
